<template>
  <div class="main-wrapper">
    <img src="../assets/alert.png" alt="Внимание!" height="150px" />
    <p>
      {{ msg }}
      <br/>
      Перейти на<a v-bind:href="url + '/idrdb/index.html'"> главную страницу</a>.
    </p>
  </div>
</template>

<script>
export default {
  props: { url: String, pageInfo: {} },
  name: "NotValidVersion",
  data: () => ({
    msg: ""
  }),
  created() {
    this.pageInfo.ERROR_MSG == null || this.pageInfo.ERROR_MSG.length == 0
      ? (this.msg = "Неизвестная ошибка.")
      : (this.msg = this.pageInfo.ERROR_MSG);
  }
};
</script>

<style scoped>
</style>